import { AxiosResponse } from 'axios';
import { IconSetData } from '../types/IconSetData';
import { get, put } from './baseAxios';
import { API_ICON_SET } from '../utils/urls';

const url = API_ICON_SET;

export const getDefaultIconSet = (): Promise<AxiosResponse<IconSetData>> => get(`${url}/default`);
export const addIcons = (request: IconSetData): Promise<AxiosResponse<IconSetData>> =>
  put(`${url}/add-icons`, request);

export const removeIcons = (request: IconSetData): Promise<AxiosResponse<boolean>> =>
  put(`${url}/remove-icons`, request);
